import React from "react";
import "../../App.css";

export default function Rules() {
  return (
    <div className="rules">
      <h1>TSCL SOFTBALL LEAGUE RULES OF PLAY</h1>
      <h4>
        Note: For areas not covered or excepted in these rules standard baseball
        rules will apply. The Executive Committee, on reviewing any situation,
        can potentially penalize a team for disregard or league rules. It is the
        responsibiity of captains to ensure all players understand and follow
        the rules.
      </h4>
      <br />
      <h3>Key Rules & Update Summary </h3>

      <ul>
        <h5>Length of Game</h5>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} No new inning will start after <u>75 MINUTES</u> of play. The 75
          minute count starts at scheduled game time not actual start time. Last
          inning must be called <u>PRIOR</u> to a new inning starting.
        </li>
      </ul>
      <ul>
        <h5>Fielding</h5>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} For safety of the runner there will be no plays to first base
          from an outfielder. There must be at least 3 female players in the
          field (infield OR outfield) at all times.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Minimum player requirements:
          <ol>
            - Each team is expected to field a minimum lineup/batting order of 7
            players. Each team must have a minimum of 3 female player spots in
            their batting lineup and on the field. If a team only has 2 females,
            the 3rd female spot in the batting order is an auto-out, and the
            team may not have a rover. If a team only has 1 female the result is
            a default win for the opposing team.
          </ol>
          <ol>
            - <em>EXCEPTION</em> - If an injury during a game causes player
            minimums to not be met the team should attempt to continue play with
            a reduced lineup, although a male player can not replace an injured
            female player. If only one female player remains, an automatic out
            will apply where the injured female player was batting and the team
            must play short that player's position in the field.
          </ol>
        </li>
        <br />
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Base coaches:
          <ol>
            - Each team must provide a coach for first and third base each
            inning while batting.
          </ol>
          <ol>
            - Coaches are also expected to make loud, clear safe/out calls on
            the bases – the <strong>First Base Coach </strong> calls plays at
            first, <strong>Pitchers</strong> will make calls at Second base
            while the <strong>Third Base Coach</strong> calls plays at third.
            The Third Base Coach will also make calls on runners tagging up and
            leaving third base too early on fly balls.{" "}
            <strong>Designated Scorekeeper </strong>
            will make calls on home{" "}
          </ol>
          <ol>
            - It is the responsibility of captains to ensure coaches make fair
            and accurate calls to the best of their ability, and if necessary
            replace coaches that are not effectively or fairly making calls.
          </ol>
          <ol>
            - Only captains can overrule a Base Coaches' call, and only after
            discussing and agreeing on the change. No other player can dispute a
            call made by a coach. If no agreement is reached by the captains the
            play stands as called and if necessary the issue can be reviewed
            with the Executive Committee. An opposing captain may request
            replacement of a base coach in the event of disagreements.
          </ol>
        </li>
        <br />
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Batting:
          <ol>
            - Teams pitch to their own batters. Pitcher must stand within a
            'pitchers mound' area which is a few feet on either side of the line
            from second to home in the middle of the infield. All players, male
            or female, get a maximum of 4 pitches. Foul balls are included in
            this count; dead balls are not included.
          </ol>
          <ol>
            - When a batter has 2 strikes against them, 1 foul ball is allowed
            (which would be the 3rd pitch).
          </ol>
          <ol>
            - Dead balls are batted balls that hit the pitcher or pitching
            safety net. As mentioned above they are not counted as a pitch.
          </ol>
          <ol>
            - A pop-up to catcher must reach 8 feet to be considered an out.
          </ol>
          <ol>
            - No bunting allowed. Batted balls must be hit with a full swing.
            There is NO minimum distance for a hit, as long as a full swing is
            made.
          </ol>
          <ol>
            - <u>The Mercy Rule:</u> is based on runs scored, regardless of the
            number of players in the batting order. Once the 8th run has crossed
            the plate, the inning will be over once the current play is
            considered complete. This means that the maximum number of runs in
            an inning may be anywhere from 8 (last runner to cross the plate is
            number 8) to 11 (bases loaded and the next batter hits a grand slam,
            assuming 7 runs have already been scored). For example, say 7 runs
            have already been scored and there are currently two runners on base
            (e.g,. 1st and 3rd). If the next batter knocks in both runners but
            only reaches second themself, the inning is over and total runs
            counted will be 9. In the 7th inning, and any extra innings, no
            mercy rule will apply. Mercy rule applies for innings 1 - 5 and 6 -
            7 are open.
          </ol>
          <ol>
            - There must be at least 3 females in the batting order. The maximum
            number of male players that can bat consecutively at any point in
            the order is 3. If you start with 3 male players at the top of the
            batting order then you must have a female at the bottom of the
            order.
          </ol>
          <ol>
            - If there are insufficient female players to provide for the
            maximum to be met it is permitted to repeat females in the batting
            order, provided there are at least 3 females and each has a turn at
            bat before one bats again. Example of a batting order consisting of
            12 males and 3 females – M1,M2,M3,Female 1, M4,M5,M6,Female 2,
            M7,M8,M9,Female 3, M10,M11,M12,Female 1. Next time through the order
            it would go M1,M2,M3,Female 2, and so on.
          </ol>
        </li>
        <br />
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Fielding:
          <ol>
            - The maximum players that can play in the field at one time is 9.
            There must be at least 3 female players in the field (infield OR
            outfield) at all times (see Team Guidelines for exception).
          </ol>
          <ol>
            - If only 7 players are available, the opposing team will supply a
            catcher to return pitches only – this player will not be expected to
            play the position and should not interfere with potential plays at
            home.
          </ol>
          <ol>
            - No infielder can move within the baselines until the ball has been
            hit. Outfielders (including rovers) must remain on the outfield
            grass until the ball is in play.
          </ol>
          <ol>
            - For safety of the runner there will be no plays to first base from
            an outfielder.
          </ol>
          <ol>
            - Fielders should not impede the baselines unless making a play on a
            live ball. In this case the baserunner should attempt to avoid the
            fielder and not interfere with the fielder's play on the ball.
            Baserunners should attempt to avoid contact with fielders at all
            times. Fielders are not permitted to impede the baselines unless
            playing a live ball or making a tag. Fielders must make an effort to
            not be directly on any base, rather they should attempt to be on the
            edge of the base so that they do not impede the baserunner.
            Accidents will happen, but if contact other than accidental occurs
            this will be reviewed by the Executive Committee and the player (or
            players) involved may be suspended or expelled from the league.
          </ol>
          <ol>
            - Standard force out and tag out rules apply at first, second and
            third base. A third out made before a runner crosses the line at
            home means the run does not count.
          </ol>
          <ol>
            - To make an out at home plate, the catcher (or other fielder)
            simply needs to be standing on home plate in full possession of the
            ball before the baserunner crosses the first base line behind home
            plate (or touches a base set up along that line behind home plate) –
            see Baserunning rules. If necessary, a batter can also be tagged out
            before reaching home.
          </ol>
        </li>
        <br />
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Baserunning:
          <ol>
            - No sliding is permitted. A baserunner that{" "}
            <u>slides at any time</u> is considered out. Reaching back to touch
            a base that has been overrun is not considered a slide, although
            taking more than a step and diving on the ground to touch a base is.
          </ol>
          <ol>
            - No tagging up on fly balls, except from third base. Caught foul
            balls are included in tag up rules. The coach on third base should
            make the call on appeal of the batter leaving the base too early.
            Any disagreement should be settled between the captains. If no
            agreement can be reached the play stands as called and the incident
            should be reported to the rules committee for review. On a play at
            home on a tag up play no other baserunners can advance on an
            overthrow.
          </ol>
          <ol>
            - No leading off or stealing bases. A baserunner must be in contact
            with the base until the ball is hit. A team will receive one warning
            and afterwards any baserunner that leaves the base before the ball
            is hit is out.
          </ol>
          <ol>
            - Baserunners that overrun second and third base are considered live
            and can be tagged out. No tag can be applied to a runner that
            overruns first base unless the runner begins obvious movement
            towards second base.
          </ol>
          <ol>
            - maximum of one base will be permitted on any overthrow that leaves
            the field of play (as per standard baseball rules).{" "}
            <strong>
              <em>'One base'</em>
            </strong>{" "}
            is defined as: If the runner was moving, the next base after the
            base they were heading towards at the time of the overthrow. (ie. a
            runner heading to second gets to go to third)
          </ol>
          <ol>
            - A base runner hit by a live batted ball while in fair territory
            and not touching a base is considered out but the ball is still live
            and play may continue until time is called.
          </ol>
          <ol>
            - Baserunners must not step on home plate when attempting to score a
            run. A runner that steps on the plate is out – no exceptions. To
            score a run the runner only needs to cross a line behind home plate
            that extends from the first base line. As an alternative, an extra
            base or cone can be set up along that line two or three paces behind
            home and the runner can step on this base or past the cone to score.
          </ol>
          <ol>
            - There is a defined commitment line between third base and home,
            which will be marked on the field.
          </ol>
          <ol>
            - Pinch runners are permitted during the course of a game. Each team
            gets 3 runner substitutions per game. A male must be replaced by a
            male, a female by a female.
          </ol>
          <ol>
            - Baserunners should attempt to avoid contact with fielders at all
            times. Fielders are not permitted to impede the baselines unless
            playing a live ball or making a tag. Fielders must make an effort to
            not be directly on any base, rather they should attempt to be on the
            edge of the base so that they do not impede the baserunner.
            Accidents will happen, but if contact other than accidental occurs
            this will be reviewed by the rules committee and the player (or
            players) involved may be suspended or expelled from the league.
          </ol>
        </li>
      </ul>
      <ul>
        <h5>Equipment, Field Rules and Administration</h5>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} No metal cleats or spikes are permitted. Rubber or plastic spikes
          are fine.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} The schedule will indicate home or visitor status. At the field,
          the 3rd base dugout goes to the home team, 1st base dugout to the
          visiting team.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Bases should be set up 60 feet apart.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} The league will provide all game balls. A game ball should be a
          gold or grey dot and should be in good condition at the beginning of
          the game. The ball must be yellow in colour.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Captains must submit lineup cards to the score keeper before the
          game begins. The lineup card covers the 1st rotation through the
          batting order.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Games should start by their scheduled time. There will be a 15
          minute grace period for late-comers to show up if the team does not
          have the minimum amount of players. Games cannot be delayed because a
          team is waiting for a specific player. Any team that does not have
          sufficient players to meet the minimum requirements after the grace
          period time will be subject to a default loss. If a player is late and
          the first inning has ended, you may still have them in your line-up
          but will count as an automatic out until their arrival.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Games will be played to a standard length of 7 innings, time
          permitting. No new inning will start after 75 MINUTES of play. The 75
          minute count starts at scheduled game time not actual start time.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} League standings will be updated via the iScore program and
          posted weekly on the iScore league website. The points will be
          determined as follows:
          <ol>Win = 2 points</ol>
          <ol>Tie = 1 point </ol>
          <ol>Loss = 0 points</ol>
          <ol>Default = -1 points</ol>
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Rainouts will be mutually decided between GM’s of scheduled
          opposing teams.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} A team not able to play a scheduled game should notify opposing
          captain as well as the Executive Committee by 17:00 of the previous
          day. The game MAY be rescheduled later in the year. If a team does not
          notify anyone that they will be defaulting, a $25 dollar fine will be
          incurred for the first infraction, and a $50 dollar fine for further
          infractions.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} The Executive committee (currently) is made up of GM’s from all
          teams.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} All teams will qualify for the playoffs. Final placement will
          determine matchups and number of games in playoffs.
        </li>
        <li>
          {" "}
          <i class="fas fa-baseball-ball" />
          {""} Players must play a minimum of 6 games to qualify for the
          playoffs. Games that are cancelled do not count for a player's
          qualification.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Ground Rule - All batted balls that hit the trees in right field
          are home runs. Only in the unlikely situation where the ball brushes
          the bottom of the leaves (and trajectory DOES NOT change) is the ball
          still considered live.
        </li>
        <li>
          <i class="fas fa-baseball-ball" />
          {""} Home Run Differential Rule - No team can be up in home runs over
          the other team by more than <u>FOUR</u> during any point in the game.
          Any team that creates a difference higher than 4 home runs over
          another team will receive an automatic out.
        </li>
      </ul>
      <footer>
        This website was coded by Amber Purnis and is
        <a
          href="https://github.com/amberleighpurnis/tcsl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          open-sourced on GitHub
        </a>
      </footer>
    </div>
  );
}
